import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ConfirmedValidator } from '../../../validators/ConfirmedValidator';
import { SubscriberService } from 'src/app/services/subscriberService/subscriber.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.less']
})
export class ResetPasswordComponent implements OnInit {
  resetGroup: FormGroup;
  message;
  hide = true;
  hide2 = true;
  constructor(private formBuilder: FormBuilder, private activatedRoute: ActivatedRoute, private subscriberService: SubscriberService) {
    const reqex = ".{6,}";
    this.resetGroup = this.formBuilder.group({
      token: ['', Validators.required],
      password: ['', [Validators.required, Validators.pattern(reqex)]],
      confirmPassword: ['', [Validators.required, Validators.pattern(reqex)]]
    }, {
      validator: ConfirmedValidator('password', 'confirmPassword')
    })
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.resetGroup.controls.token.setValue(this.activatedRoute.snapshot.params['token']);
    });
  }

  // Reset Password
  resetPassword() {
    this.subscriberService.resetPassword({
      token: this.resetGroup.controls.token.value,
      password: this.resetGroup.controls.password.value
    })
  }
}